import React, { lazy, Suspense, Fragment } from 'react';
import { connect } from 'react-redux';
import { setToggleAuthSetting } from '../../actions/css';
import { getAllProducts, } from '../../actions/product'
import { getSingleProductCategory, setSelectedListings, getSelectedListings } from '../../helpers/product';
import { setSelectedListing, setSearchModalDisplay } from '../../actions/filterSearch';
import { setMaxCountLocal, } from '../../helpers/pagination';
import { setProductModalState } from '../../actions/product';
import  getTouchCount from '../../helpers/pagination';
import Loader from '../Loader/Loader';
import SearchFilter from '../SearchPage/SearchFilter';
import FilterPropertyCard from '../../components/Cards/FilterListingsCard';
import Listings53025 from '../../helpers/Listings/Listings53025';
import Recommended from '../../helpers/DropDowns/Recommended';
import OnDemand from '../../helpers/DropDowns/onDemand';
import AdsBannerHelperOil from '../../helpers/HomePage/AdsBannerHelperOil';
import AdsBanner from '../../helpers/HomePage/AdsBanner';

import { setListingID } from '../../actions/filterSearch';
import Pagination from '../Pagination/Pagination';


class ResultSearch extends React.Component{
  componentDidMount (){
    const { dispatch } = this.props; 
    try{
    // const getSingleProduct = getSingleProductCategory();
    //  dispatch(getAllProducts(getSingleProduct.toString()));
    }catch(err){
    //  dispatch(getAllProducts());
    };
  };

  componentWillMount (){
    const { dispatch } = this.props; 
    dispatch(setProductModalState(undefined));
    dispatch(setToggleAuthSetting(false));
  };

  componentDidUpdate(){
    window.scrollTo(0,0);
  };

 numberWithCommas = x => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

  render(){
    const { dispatch } = this.props;
    const { localArea, listingType, purchaseOption, listingID  } = this.props.filterSearch;
    const { pagCount } = this.props.pagCount;
    //fix this
    // const getFilterListings = Listings53025.filter(data => (data.city === localArea) && 
    // (data.category === listingType) && (data.type === purchaseOption ));

    let getFilterListings = [];
    let getSingleListing = [];

    if(!!listingType && (listingType === 'Residential') || 
      (listingType === 'Office Space') || (listingType === 'Commercial Property')){
        getFilterListings = Listings53025.filter(data => (data.city === localArea) && 
        (data.category === listingType) && (data.type === purchaseOption ));
    }else{
      getFilterListings =[ ...Listings53025, ...AdsBanner(), ...AdsBannerHelperOil(),  ...Recommended, ...OnDemand ].filter(data => (data.city === localArea) && 
      (data.category === listingType));
    };
    
    getSingleListing = [...Listings53025, ...Recommended, ...OnDemand, 
      ...AdsBannerHelperOil(), ...AdsBanner() ].filter(data => (data.productRef === Number(listingID)));




    const paginateSelectedListings = () => {
      const resultOfPagination = getTouchCount(pagCount, getFilterListings);
      return resultOfPagination[0];
    };

    // paginateSelectedListings();
    // setMaxCountLocal(paginateSelectedListings().maxCount);
    setSelectedListings(JSON.stringify(paginateSelectedListings()));
    // setMaxCountLocal(JSON.parse(localStorage.getItem('selectedListings')));
    setMaxCountLocal(JSON.parse(getSelectedListings()).maxCount);


    return (
      <div className='request-display-div'>
        <div className='request-title-info-div'>

          <div className='search-product-id-div'>
            {!!getSingleListing && getSingleListing.length > 0  ? <a href='#' onClick={() => {
              dispatch(setListingID(''));
            }}>close</a> : ''}
            {!!getSingleListing && getSingleListing.length > 0 
                    ? getSingleListing.map(data => (
                    <div key={`${data.title}${data.productId}`}  onClick={() => {
                      dispatch(setSelectedListing(data));
                      dispatch(setSearchModalDisplay(true));
                    }}>
                      <Fragment>
                        <FilterPropertyCard 
                          imgURL={data.imgUrl1}
                          propertyTitle = {`${data.title} @ ${data.areaName}, ${data.city}`}
                          propertyShortDesc= {data.shortDescription}
                          propertyPrice = {`${data.currency}${data.displayPrice}`}
                          key={`${data.title}${data.productId}`}
                        />
                      </Fragment>
                    </div>
                )) : <Fragment>
                      {/* <Loader /> */}
                    </Fragment>}
          </div>

          <p className='request-info-display-name'>
            {!!paginateSelectedListings().listing && paginateSelectedListings().listing.length < 1 ? 
              <span>No Listings found</span> : <span>Your Listings for the week.</span>}
          </p>
          <div className='search-result-div'>
           <Suspense fallback={<Loader />}>
             <Fragment>
               <div className='result-filter-div'>
                <div className='result-filter-div-filter'>
                  <SearchFilter />
                </div>
                <div className='filter-group-listings'>
                  {!!paginateSelectedListings().listing && paginateSelectedListings().listing.length > 0 
                    ? paginateSelectedListings().listing.map(data => (
                    <div key={`${data.title}${data.productId}`}  onClick={() => {
                      dispatch(setSelectedListing(data));
                      dispatch(setSearchModalDisplay(true));
                    }}>
                      <Fragment>
                        <FilterPropertyCard 
                          imgURL={data.imgUrl1}
                          propertyTitle = {`${data.title} @ ${data.areaName}, ${data.city}`}
                          propertyShortDesc= {data.shortDescription}
                          propertyPrice = {`${data.currency}${data.displayPrice}`}
                          key={`${data.title}${data.productId}`}
                        />
                      </Fragment>
                    </div>
                )) : <Fragment>
                      <Loader />
                    </Fragment>}
                </div>
               </div>
               {!!paginateSelectedListings().listing && paginateSelectedListings().listing.length > 0 ? <Pagination /> : <p></p>}
             </Fragment>
           </Suspense>
          </div>
        </div>
      </div>
    )
  };
};


const mapStateToProps = (state) => state;

export default connect(mapStateToProps)(ResultSearch); 
